import { render } from "./EntryPoint.vue?vue&type=template&id=271c7e0a&scoped=true"
import script from "./EntryPoint.vue?vue&type=script&lang=js"
export * from "./EntryPoint.vue?vue&type=script&lang=js"

import "./EntryPoint.vue?vue&type=style&index=0&id=271c7e0a&scoped=true&lang=less"
import "./EntryPoint.vue?vue&type=style&index=1&id=271c7e0a&lang=less"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\spiel26-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271c7e0a"]])

export default __exports__